// Autogenerated by `pnpm version-file`. DO NOT EDIT
export const VERSION = '1.42.3';
